import React from 'react';
import IntentSelector from 'components/app/intents/IntentSelector';
import Intent from 'components/app/intents/Intent';
import ConflictWarning from './components/ConflictWarning';
import withStyles from 'helpers/withStyles';

const styles = theme => ({
  intent: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
});

const SchedulerIntentCell = ({
  block,
  variant,
  actionMode,
  unscheduledIntents,
  onIntentUpdate,
  onIntentDelete,
  onStatusChange,
  onIntentSchedule,
  onScheduleExtend,
  classes,
}) => (
  block.intent
    ? <div className={classes.intent}>
        <Intent
          value={block.intent}
          variant={variant}
          component="div"
          actionMode={actionMode === 'edit' ? 'remove' : actionMode}
          onStatusChange={status => onStatusChange(block.intent, status)}
          onUpdate={onIntentUpdate}
          onDelete={onIntentDelete}
          onRemove={intent => onIntentSchedule(intent, undefined)}
        />

        {/* HACK: `onScheduleExtend` is only set in `Schedule` scene. This prevents the warning
                  being displayed on other pages that use the scheduler. [twl 30.Sep.20] */}
        {onScheduleExtend && block.conflictDuration > 0 &&
          <ConflictWarning
            intent={block.intent}
            type={block.conflictType}
            duration={block.conflictDuration}
            onUpdate={onIntentUpdate}
            onRemove={intent => onIntentSchedule(intent, undefined)}
            onScheduleExtend={onScheduleExtend}
          />
        }
      </div>
    : !block.intent && actionMode === 'edit'
      ? <IntentSelector
          intents={unscheduledIntents}
          sortBy={[
            { property: 'duration', direction: 'desc', sortNulls: 'bottom' },
            'todo.title',
          ]}
          onChange={intent => intent.duration && onIntentSchedule(intent, block.start)}
        />
      : ' '
);

export default withStyles(styles)(SchedulerIntentCell);
